<template>
  <div id="wrapper-dashboard-index">
    <template v-if="!isLoading">
      <b-container fluid class="p-0" v-if="!lumbredocs_v3">
        <b-row no-gutters>
          <b-col class="col-2 columnMenu" :class="{'columnMenu-collapsed': !expanded}">
            <LmColumnMenu
              :isLoading="isLoading"
              :menuItems="mainMenuItems"
              @expanded="expanded=$event"
            />
          </b-col>
          <b-col class="col-10 appContainer" :class="{'columnMenu-collapsed': !expanded}">
            <LmHeader />
            <!-- "key" fixea un problema al cambiar de subrutas dentro de una ruta principal -->
            <router-view :key="$route.path" class="lumbreApp" />
            <LmFooter />
          </b-col>
        </b-row>
        <b-alert
          class="mt-2 alert"
          :show="hideCounter"
          variant="warning"
          v-if="showRequestPermissionAlert"
          >
          <div class="d-flex align-items-center">
            <font-awesome-icon icon="info-circle" class="mr-2 fa-lg"></font-awesome-icon>
            <span>{{ alertRequestNotificationMessage }}</span>
            <button class="btn btn-link ml-2 p-0 border-0" @click="requestPermission(); close()">Aceptar</button>
          </div>
        </b-alert>
      </b-container>

      <section class="lumbre-container" v-else>
        <LmHeader @toggleMenu="expanded = !expanded" />

        <div class="lumbre-app">

          <div class="app-menu" :class="{ 'expanded': expanded }">
            <LmMenu :expanded="expanded" @expand="expanded = true" />
          </div>

          <section class="app-view">
            <router-view :key="$route.path" />
            <LmFooter />
          </section>

        </div>

      </section>

      <b-alert
        class="mt-2 alert"
        :show="hideCounter"
        variant="warning"
        v-if="showRequestPermissionAlert"
        >
        <div class="d-flex align-items-center">
          <font-awesome-icon icon="info-circle" class="mr-2 fa-lg"></font-awesome-icon>
          <span>{{ alertRequestNotificationMessage }}</span>
          <button class="btn btn-link ml-2 p-0 border-0" @click="requestPermission(); close()">Aceptar</button>
        </div>
      </b-alert>

      <!-- Modal de Sesión por Expirar -->
      <b-modal
        id="modal-session" title="Sesión a punto de expirar"
        @show="startInterval()" @hidden="clear()"
        cancel-title="Cerrar sesión"
        @cancel="logout"
        ok-title="Continuar navegando"
        @ok="keepSession"
        no-close-on-backdrop
        no-close-on-esc
      >
        <p class="my-4">{{ timerMessage }}</p>
      </b-modal>

      <!-- Modal de Sesión Expirada -->
      <b-modal
        id="modal-session-expired" title="Cerramos tu sesión"
        ok-only
        ok-title="Ingresar de nuevo"
        @hide="logout"
        @ok="logout"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
      >
        <p class="my-4">Por cuestiones de seguridad dimos por finalizada tu sesión</p>
      </b-modal>
    </template>
    <!-- Loading state -->
    <template v-else>
      <LmComponentLoading />
    </template>

    <b-modal
      id="tyc-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      scrollable
    >
      <small>Version: {{ appUsageTerms.version }}</small>
      <div v-html="appUsageTerms.termsAndConditions"></div>
      <div v-html="appUsageTerms.privacyPolicies"></div>
      <template #modal-footer>
        <b-button variant="danger" disabled @click="onRejectTyC">Rechazar</b-button>
        <b-button variant="success" disabled @click="onApproveTyC">Aceptar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import commonsApi from '@/api/commons'
import LmColumnMenu from '@/components/LmColumnMenu.vue'
import LmMenu from '@/components/LmMenu'
import LmHeader from '@/components/LmHeader.vue'
import LmFooter from '@/components/LmFooter.vue'

import lmToasts from '@/mixins/lmToasts.js'
import lmNotifications from '@/mixins/lmNotifications'

import { EventBus } from '@/event-bus.js'

// https://github.com/pubkey/broadcast-channel
import { BroadcastChannel } from 'broadcast-channel'

export default {
  inject: ['lumbredocs_v3'],
  props: ['hijos'],
  mixins: [lmToasts, lmNotifications],
  data () {
    return {
      title: 'LumbreDocs',
      expanded: true,
      hideCounter: 100000,
      alertRequestNotificationMessage: process.env.VUE_APP_ALERT_REQUEST_NOTIFICATION_MESSAGE,
      seconds: 120,
      interval: null,
      modalTimeout: '',
      isLoading: false
    }
  },
  sockets: {
    connect (data) {}
  },
  components: {
    LmColumnMenu,
    LmHeader,
    LmFooter,
    LmMenu
  },
  computed: {
    ...mapState('settings', ['mainMenuItems', 'loading', 'favicon', 'faviconDot', 'appUsageTerms']),
    ...mapGetters('settings', ['googleMapsApiKey']),
    ...mapState('toast', ['isToastErrorVisible', 'errorObject']),
    timerMessage () {
      // Sesión expirada
      if (this.seconds < 1) {
        this.clear()
        this.$bvModal.hide('modal-session')
        this.$bvModal.show('modal-session-expired')
        return
      }
      return `Su sesión expirará en ${this.seconds} segundos.`
    },
    isOnMobileMode () {
      return window.innerWidth <= 768
    }
  },
  watch: {
    '$route.path' () {
      if (this.isOnMobileMode) {
        this.expanded = false
      }
    }
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings', 'getCustomerSettings']),
    ...mapMutations('settings', ['mutateAppUsageTerms']),
    ...mapActions('session', ['getUserInfo', 'preventSessionToExpire']),
    ...mapMutations('session', ['mutateExpiresAt']),
    ...mapActions('toast', ['actionHideToastError']),
    close () {
      this.hideCounter = 0
    },
    startInterval () {
      this.interval = setInterval(() => {
        this.seconds = this.seconds - 1
      }, 1000)
    },
    stopSeconds () {
      if (this.interval) clearInterval(this.interval)
      this.interval = null
    },
    clear () {
      this.stopSeconds()
      // Asigno 2 minutos de tiempo para que el usuario pueda ver y aceptar el modal
      this.seconds = 120
    },
    async keepSession () {
      await commonsApi.axiosGetWrapper(`/users/ping`)
    },
    async logout () {
      try {
        await this.$store.dispatch('session/logout')
      } catch (error) {
        console.log('error logout sesion expirada', error)
      } finally {
        location.replace('/login')
      }
    },
    startTimeout (ttl) {
      clearTimeout(this.modalTimeout)
      this.modalTimeout = setTimeout(() => {
        this.$bvModal.show('modal-session')
      }, ttl)
    },
    async onApproveTyC () {
      try {
        await commonsApi.axiosPutWrapper('/tyc/approve', {
          id: this.appUsageTerms._id
        })
        this.$bvModal.hide('tyc-modal')
      } catch (error) {
        await this.logout()
      }
    },
    async onRejectTyC () {
      await this.logout()
    },
    async validateTyC () {
      try {
        const response = await commonsApi.axiosGetWrapper(`/tyc/validate`)
        this.mutateAppUsageTerms(response.data.doc)
        if (!response.data.ok) {
          this.$bvModal.show('tyc-modal')
        }
        this.$nextTick(() => {
          const modal = document.querySelector('#tyc-modal .modal-body')
          if (modal) {
            modal.addEventListener('scroll', () => {
              const documentHeight = modal.scrollHeight - modal.offsetHeight - 1
              const currentScroll = modal.scrollTop
              const modifier = 80
              if (currentScroll + modifier > documentHeight) {
                const buttons = document.querySelectorAll('#tyc-modal .modal-footer button')
                for (const node of buttons) {
                  node.disabled = false
                  node.classList.remove('disabled')
                }
              }
            })
          }
        })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    // Inicializa la app
    async appInit () {
      if (!this.$store.state.session.isAuthenticated) {
        this.$router.push('/login')
        return
      }
      if (process.env?.VUE_APP_ENABLE_REAMAZE === 'yes') {
        this.validateBrowser()
      }
      await Promise.all([
        this.getMainMenuSettings(),
        this.getUserInfo(),
        process.env?.VUE_APP_ENABLE_CUSTOMERS === 'yes' ? this.getCustomerSettings() : null,
        process.env?.VUE_APP_ENABLE_TYC === 'yes' ? this.validateTyC() : null
      ])
      this.defineSessionBroadcastChannels()
    },
    // Configura la app
    appConfig () {
      this.title = this.$route.meta.title + ' - ' + this.title
      // Api google maps dinamico por cliente
      if (process.env?.VUE_APP_GOOGLE_API_DYNAMIC === 'yes') {
        // Me aseguro de no duplicar el script
        if (!document.querySelector('script[data-name="googleMapsApiScript"]')) {
          const customerGoogleMapsApiKey = this.googleMapsApiKey
          const head = document.getElementsByTagName('head')[0]
          const js = document.createElement('script')
          js.dataset.name = 'googleMapsApiScript'
          js.type = 'text/javascript'
          js.async = true
          js.src = `https://maps.googleapis.com/maps/api/js?key=${customerGoogleMapsApiKey}&libraries=places`
          head.appendChild(js)
        }
      }

      if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
        // Actualizo Menú al recibir cambios vía socket.service en el backend
        this.sockets.subscribe('menuUpdated', (data) => {
          this.getMainMenuSettings()
        })

        if (process?.env?.VUE_APP_LUMBRE_SESSION_MODAL === 'yes') {
          // Inicio el timeout de la sesión a partir de lo que intercepta Axios
          EventBus.$on('sessionUpdated', ({ ttl }) => {
            this.startTimeout(ttl)
            this.mutateExpiresAt(ttl)
          })

          // Monitoreo evento para mostrar modal
          EventBus.$on('sessionAboutToExpire', () => {
            clearTimeout(this.modalTimeout)
            this.$bvModal.show('modal-session')
          })
          EventBus.$on('sessionExpired', () => {
            clearTimeout(this.modalTimeout)
            this.$bvModal.hide('modal-session')
            this.$bvModal.show('modal-session-expired')
          })

          // Verifico la sesión cuando el usuario vuelve a la ventana
          document.addEventListener('visibilitychange', () => {
            this.preventSessionToExpire()
          })
        }
      }
    },
    defineSessionBroadcastChannels () {
      const sessionUpdatedChannel = new BroadcastChannel('sessionUpdated')
      const sessionExpiredChannel = new BroadcastChannel('sessionExpired')

      sessionUpdatedChannel.onmessage = event => {
        if (event > 0 && location.pathname !== '/login') {
          EventBus.$emit('sessionUpdated', { ttl: event })
        }
      }

      sessionExpiredChannel.onmessage = event => {
        if (event && location.pathname !== '/login') {
          EventBus.$emit('sessionExpired')
        }
      }
    },
    validateBrowser () {
      if (this.$browserDetect.isIE || this.$browserDetect.isOpera || this.$browserDetect.isSafari) {
        setTimeout(() => {
          window.Reamaze.popup('/kb/info-tecnica/navegadores-soportados')
        }, 1000)
      }
    }
  },
  async created () {
    try {
      this.isLoading = true

      await this.appInit()
      this.appConfig()
      if (process.env?.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes') {
        await this.notificationsInit()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  beforeDestroy () {
    // Cancelo el monitoreo de los eventos de Sockets y EventBus
    if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
      this.sockets.unsubscribe('menuUpdated')
      this.sockets.unsubscribe('notificationsUpdated')
    }
    if (process.env?.VUE_APP_LUMBRE_SESSION_MODAL === 'yes') {
      EventBus.$off('sessionExpired')
      EventBus.$off('sessionUpdated')
      EventBus.$off('sessionAboutToExpire')
    }
    if (process.env?.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes') {
      EventBus.$off('onMessage')
    }
  }
}
</script>

<style lang="sass" scoped>
  #wrapper-dashboard-index
    height: 100vh

    .lumbre-container
      height: 100vh

      .lumbre-app
        display: flex
        overflow: hidden
        min-height: calc(100vh - 70px)

        .app-menu
          display: none
          transition: ease-in-out all .2s
          @media (min-width: $md)
            display: flex
            flex: 0 0 8%
            &.expanded
              flex: 0 0 20%
          @media (min-width: $xxl)
            display: flex
            flex: 0 0 5%
            &.expanded
              flex: 0 0 15%
          @media (max-width: $md)
            &.expanded
              position: fixed
              z-index: 999
              display: block
              width: 85%

        .app-view
          height: calc(100vh - 70px)
          flex: 1 1 100%
          display: flex
          justify-content: space-between
          flex-direction: column
          overflow-y: auto
          overflow-x: hidden

          &::-webkit-scrollbar
            width: 8px
          &::-webkit-scrollbar-track
            background: #f1f1f1
          &::-webkit-scrollbar-thumb
            border-radius: 20px
            background: #888
          &::-webkit-scrollbar-thumb:hover
            background: #555

  // lumbreApp tiene el 100vh menos el alto de header y footer
  .lumbreApp
    height: calc(100vh - 70px - 61px)
    overflow-y: auto
    overflow-x: hidden
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-track
      background: #f1f1f1
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: #888
    &::-webkit-scrollbar-thumb:hover
      background: #555
  .columnMenu
    transition: flex-basis 0.2s ease
    flex: 0 1 265px !important
    max-width: 265px !important
    z-index: 11 !important
    &.columnMenu-collapsed
      flex: 0 0 80px !important
      max-width: 80px !important
  .appContainer
    flex-grow: 0 !important
    flex-shrink: 0 !important
    flex-basis: 100% !important
    max-width: 100% !important
    display: flex
    flex-direction: column
    min-height: 100vh
    @media(min-width: $xl)
      flex-basis: calc(100% - 265px) !important
      max-width: calc(100% - 265px) !important
      &.columnMenu-collapsed
        flex: calc(100% - 80px) !important
        max-width: calc(100% - 80px) !important
  .col-right
    display: flex
    flex-direction: column
    min-height: 100vh
  .col-left
    transition: flex-basis 0.2s ease
    @media(min-width: $xl)
      flex: 0 1 80px
    &.col-left-expanded
      @media(min-width: $xl)
        flex: 0 1 265px
  .alert
    left: 15px
    right: 15px
    margin: auto
    position: absolute
    top: 0
    @media(min-width: $lg)
      width: 50%
      left: 275px
      right: auto
    @media(min-width: $xl)
      width: auto
</style>
